var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDownBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37297 8.24309C3.7635 7.85256 4.39666 7.85256 4.78718 8.24309L11.3072 14.7631C11.6867 15.1426 12.3135 15.1426 12.693 14.7631L19.213 8.24309C19.6035 7.85256 20.2367 7.85256 20.6272 8.24309C21.0177 8.63361 21.0177 9.26678 20.6272 9.6573L14.1072 16.1773C12.9467 17.3378 11.0535 17.3378 9.89297 16.1773L3.37297 9.6573C2.98245 9.26678 2.98245 8.63361 3.37297 8.24309Z",
    fill: "#C8CCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBig);
export default __webpack_public_path__ + "static/media/ChevronDownBig.c29b543766e4646a2863171c197587e4.svg";
export { ForwardRef as ReactComponent };